import template from './numericField.html';
import controller from '../field.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
    onUpdate: '&',
  }
};

export default component;
